import styled from 'styled-components';
import { palette } from 'styles/colors';
import { layout } from 'styles/layout';

export const MemberSpotlightContainer = styled.div`
  padding: 3rem 2rem;
  border-radius: 16px;
  background: ${palette.white};
  display: grid;
  grid-template-columns: 177px 1fr;
  column-gap: 1rem;
  margin-top: 2rem;

  @media screen and (max-width: ${layout.md}) {
    grid-template-columns: 1fr;
  }
`;

export const MemberSpotlightTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 1rem;
`;

export const MemberSpotlightAvatar = styled.div`
  display: flex;
  width: 177px;
  height: 177px;
  border-radius: 50%;
  overflow: hidden;

  @media screen and (max-width: ${layout.md}) {
    margin: 0 auto 2rem auto;
  }
`;
